import { useMemo } from 'react';

import { useActiveClusters } from 'features/organization/_hooks';

import { SeveritySelect } from 'features/security-insights';
import { useBestPracticesFiltersQuery } from 'hooks/queries/security-insights';
import { LabelsSelect } from './LabelsSelect';

import { NamespaceSelect } from './NamespaceSelect';
import { ClusterSelect } from '../../_components';
import { useClustersOrFixture } from '../../hooks/useClustersOrFixture';
import { ResourcesSelect } from '../components';
import { FailedToLoad } from '@cast/shared-messages-ui';

import { ClearAllButton, Search } from '@cast/shared-search-ui';

import { Stack } from '@cast/design-system';

type ChecksFiltersProps = {
  clusterIds?: string[];
};

export const ChecksFilters = ({
  clusterIds: scopedClusterIds,
}: ChecksFiltersProps = {}) => {
  const { clusters: _clusters } = useActiveClusters();
  const { clusters } = useClustersOrFixture(_clusters);
  const clusterIds = useMemo(
    () => scopedClusterIds ?? clusters?.map((cluster) => cluster.id) ?? [],
    [scopedClusterIds, clusters]
  );
  const { error, refetch } = useBestPracticesFiltersQuery({ clusterIds });

  return (
    <Stack gap={8}>
      <Search rootSx={{ flexGrow: 1 }} />
      {error ? (
        <FailedToLoad
          title="Failed to load security report filters"
          refresh={refetch}
        />
      ) : (
        <Stack direction="row" gap={8}>
          {!scopedClusterIds && <ClusterSelect />}
          <NamespaceSelect clusterIds={scopedClusterIds} />
          <LabelsSelect clusterIds={scopedClusterIds} />
          <ResourcesSelect />
          <SeveritySelect
            sx={{ width: '100%' }}
            criterion="severity"
            testId="severity-select"
          />
          <ClearAllButton
            sx={{
              flexBasis: '84px',
              minWidth: 'auto',
              whiteSpace: 'nowrap',
            }}
          />
        </Stack>
      )}
    </Stack>
  );
};
